import { useRequest } from 'ahooks'

import { createUnfreezeApplyApi } from '@eastcoal/api/trade/unfreezeApplyMember/createUnfreezeApply'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'

import { DepositUnfreezeButtonProps } from './interface'

export const DepositUnfreezeButton = ({
  record: { bizId, bizType, type }
}: DepositUnfreezeButtonProps) => {
  const { message } = useFeedback()
  const tableReload = useRemoteTableStore(state => state.reload)

  const { loading, refresh } = useRequest(
    () =>
      createUnfreezeApplyApi({
        bizId,
        bizType,
        type
      }),
    {
      manual: true,
      onSuccess() {
        message.success('申请成功')
        tableReload()
      }
    }
  )

  return (
    <ConfirmButton
      loading={loading}
      message='确定申请释放保证金吗？'
      type='link'
      onConfirm={refresh}
    >
      释放保证金
    </ConfirmButton>
  )
}
